import './AdminDashboard.css';
import '../../App.css';
import { useEffect, useState } from 'react';
import { Table } from 'antd';
import 'antd/dist/antd.css';
import React from 'react';
import AdminSidebar from "./AdminSidebar";
import './Sidebar.css'
import { useStateValue } from "../../Component/StateProviders";
import Loader from "../../Component/Loader";


function AdminAppointmentByDate() {





    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20', '50', '100'],
        showSizeChanger: true,
    });

    const handleTableChange = (pagination) => {
        setPagination(pagination);
    };


    const [loaderon, setloaderon] = useState({});
    const [loaderonpay, setloaderonpay] = useState({});

    const findBookingIndex = (id) => {
        const index = AppointmentData.findIndex(booking => booking.BookingId === id);
        return index;
    };

    function Pending_Payment(Paymentindex, BookingId) {
        var Url = window.API_PREFIX + 'admin/Paybydoctor'
        var BookingIndex = findBookingIndex(BookingId)
        setloaderonpay({ ...loaderonpay, [Paymentindex]: true });
        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId'],
                    PatientId: AppointmentData[BookingIndex]['PatientId']


                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            setloaderonpay({ ...loaderonpay, [Paymentindex]: false });
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp[BookingIndex]['BookingStatus'] = 2
                setAppointmentData([...tmp])
            }
        })

    }


    function Delete_Appointment(Requestindex, BookingId) {
        var Url = window.API_PREFIX + 'booking/delete_booking'
        // dispatch({
        //     type: 'StartLoad'
        // })
        var BookingIndex = findBookingIndex(BookingId)

        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId']


                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            // dispatch({
            //     type: 'StopLoad'
            // })
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp.splice(BookingIndex, 1)
                setAppointmentData([...tmp])
            }
        })


    }


    function RestoreRequest(Requestindex, BookingId) {
        var Url = window.API_PREFIX + 'booking/restore_trash_booking'
        // dispatch({
        //     type: 'StartLoad'
        // })
        var BookingIndex = findBookingIndex(BookingId)

        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId']


                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            // dispatch({
            //     type: 'StopLoad'
            // })
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp.splice(BookingIndex, 1)
                setAppointmentData([...tmp])
            }
        })


    }

    function TrashDelete(Requestindex, BookingId) {
        var Url = window.API_PREFIX + 'booking/trash_booking'
        var BookingIndex = findBookingIndex(BookingId)

        // dispatch({
        //     type: 'StartLoad'
        // })
        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId']


                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            // dispatch({
            //     type: 'StopLoad'
            // })
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp.splice(BookingIndex, 1)
                setAppointmentData([...tmp])
            }
        })


    }

    function AcceptRequest(Requestindex, BookingId) {
        var Url = window.API_PREFIX + 'booking/approve_booking'
        var BookingIndex = findBookingIndex(BookingId)
        setloaderon({ ...loaderon, [Requestindex]: true });
        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId']


                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            setloaderon({ ...loaderon, [Requestindex]: false });
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp[BookingIndex]['BookingStatus'] = 2
                setAppointmentData([...tmp])
            }
        })


    }





    function RejectRequest(Requestindex, BookingId) {


        var Url = window.API_PREFIX + 'booking/reject_booking'
        setloaderon({ ...loaderon, [Requestindex]: true });
        var BookingIndex = findBookingIndex(BookingId)

        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId'],




                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            setloaderon({ ...loaderon, [Requestindex]: false });
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp[BookingIndex]['BookingStatus'] = -1
                setAppointmentData([...tmp])
            }
        })

    }



    // function AcceptRequest(Requestindex) {
    //     var tmp = AppointmentData
    //     tmp[Requestindex]['BookingStatus'] = 1
    //     setAppointmentData([...tmp])
    // }

    // function RejectRequest(Requestindex) {
    //     var tmp = AppointmentData
    //     tmp[Requestindex]['BookingStatus'] = -1
    //     setAppointmentData([...tmp])
    // }



    const columns = [
        {
            title: 'Client Name',

            dataIndex: 'PatientName',
            key: 'name',
            //   render: (text) => <a>{text}</a>,
            render: (text, record) => <>
                <div className='mitwank_dashboard_table_image_name_division'>
                    <div className='mitwank_dashboard_table_image_division'>
                        <img className='mitwank_dashboard_table_image' src={record['ProfilePic']}
                            height="50px" width="50px" /></div>
                    <div className='mitwank_dashboard_table_name_id_division'>
                        <div className='mitwank_dashboard_table_patient_name'>{text}</div>
                        <div className='mitwank_dashboard_table_patient_id'>#pt{record['PatientId']}</div>
                    </div>
                </div>
            </>

        },
        {
            title: 'Appt Date',
            dataIndex: 'Date',
            key: 'date',
            render: (text, record) => <>
                <div className='mitwank_dashboard_time_date_div'>
                    <div className='mitwank_dashboard_table_appt_date'>{text}</div>
                    <div className='mitwank_dashboard_table_appt_time'>{record['Time']}</div>
                </div>
            </>
        },
        {
            title: 'Package',
            dataIndex: 'Purpose',
            key: 'package',
            render: (text, record) => <>
                <div className='mitwank_dashboard_table_appt_date'>{text}</div>

            </>
        },
        // {
        //     title: 'Type',
        //     dataIndex: 'Patienthistory',
        //     key: 'type',
        //     render: (text, record) => <>
        //         <div className='mitwank_dashboard_table_appt_date'>{text ? 'Old Patient' : 'New Patient'}</div>
        //     </>
        // },
        {
            title: 'Paid Amount',
            dataIndex: 'Amount',
            key: 'paidamount',
            //         render: (text,record) => <>
            //         <div className='mitwank_dashboard_table_appt_date'>{text}</div>

            // </>
        },
        {

            title: 'Option',
            key: 'tags',
            dataIndex: 'BookingStatus',
            render: (text, record, index) => (
                <>
                    {text === 0 ? <div className='mitwank_dashboard_tabel_view_accept_cancel'>

                        {
                            loaderon[index] ? <Loader /> :
                                <button className='btn mitwank_dashboard_tabel_accept_btn'
                                    onClick={() => {
                                        AcceptRequest(index, record.BookingId)
                                    }}
                                >Accept</button>
                        }



                        {
                            loaderon[index] ? <Loader /> :
                                <button className='btn mitwank_dashboard_tabel_cancel_btn'

                                    onClick={() => {
                                        RejectRequest(index, record.BookingId)
                                    }}
                                >Reject</button>
                        }


                    </div>
                        : text === 1 ?
                            <div className='mitwank_dashboard_tabel_view_accept_cancel'>
                                <div><button className='btn mitwank_dashboard_tabel_accept_btn' disabled>Accepted</button></div>
                            </div>
                            : text === 2 ?
                                <div className='mitwank_dashboard_tabel_view_accept_cancel'>
                                    <div><button className='btn mitwank_dashboard_tabel_accept_btn' disabled>Accepted</button></div>
                                </div>
                                :
                                <div className='mitwank_dashboard_tabel_view_accept_cancel'>
                                    <div><button className='btn mitwank_dashboard_tabel_cancel_btn' disabled>Rejected</button></div>
                                </div>
                    }
                </>
            ),
        },
        {

            title: 'Payment Status',
            key: 'tags',
            dataIndex: 'Ispaid',
            render: (text, record, index) => (
                <>
                    <div className='mitwank_dashboard_tabel_view_accept_cancel'>
                        {record['BookingStatus'] === 1 || record['BookingStatus'] === 2 ? (
                                <div>
                                    <button className='btn mitwank_dashboard_tabel_accept_btn' disabled>
                                        Completed</button>
                                </div>
                            ) : record['BookingStatus'] === 0 ? (
                                    <div><button className='btn mitwank_dashboard_tabel_view_btn' disabled>
                                        Pending Request</button></div>
                            ) : (
                                    <div><button className='btn mitwank_dashboard_tabel_cancel_btn' disabled>
                                        N/A</button></div>
                            )}
                        {/* <div><button className='btn mitwank_dashboard_tabel_cancel_btn'><i class="fa-regular fa-eye me-1"></i>Cancel</button></div> */}
                    </div>
                </>
            ),
        },
    ];

    const [AppointmentData, setAppointmentData] = useState([])
    const [NonSearchAppointmentData, setNonSearchAppointmentData] = useState([])
    const [FilterDate, setFilterDate] = useState([])
    const [AppointmentOption, setAppointmentOption] = useState([true, false, false])

    useEffect(() => {

        var Url = window.API_PREFIX + 'admin/All_booking'
        fetch(Url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            },
            // body: JSON.stringify({'Token':localStorage.getItem('DToken')}),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            if (data['status'] === "1") {
                setAppointmentData([...data["Booking"]])
                setNonSearchAppointmentData([...data["Booking"]])
            }
        })
    }, [])



    return (
        <>
            <div className="container-fuild mx-2">
                <div className='mitwank_dashboard_main_diviison'>
                    {/* <span className='mitwank_dashboard_patientappoinment_name'>Appoinment By Date</span> */}
                    <div className='mitwank_dashboard_patientappoinment_date_division'>
                        <input type="date" className='mitwank_dashboard_patientappoinment_celender' id="birthday" name="birthday"
                            onChange={(e) => {
                                const date = new Date(e.target.value);
                                const formattedDate = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
                                console.log(formattedDate)
                                setFilterDate(formattedDate)
                            }}
                        />
                        <button className='btn mitwank_dashboard_patientappoinment_date_btn'
                            onClick={
                                () => {

                                    console.log("FilterDate", FilterDate)
                                    setAppointmentData([...NonSearchAppointmentData.filter(item => item.Date === FilterDate)]);

                                    if (FilterDate === "" || FilterDate === 'Invalid Date') {
                                        setAppointmentData([...NonSearchAppointmentData])
                                    }
                                }
                            }
                        >Apply</button>
                    </div>
                </div>
                <div className='mitwank_dashboard_patient_appointment_table_main_division'>
                    <div className='mitwank_dashboard_patient_appointment_table_division'>
                        <Table columns={columns} dataSource={AppointmentData} pagination={pagination}
                            onChange={handleTableChange} />
                    </div>
                </div>
            </div>

        </>
    )
}
export default AdminAppointmentByDate;